import React, { useEffect, useState } from 'react';
import './Insurance.css';
import { Link } from 'react-router-dom';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import CARINSURANCE from '../images/CARINSURANCE.png';
import BIKEINSURANCE from '../images/BIKEINSURANCE.png';
import EXPLAININSURANCE from '../images/EXPLAININSURANCE.png';
import ALLINSURANCE from '../images/ALLINSURANCE.jpg';
import HEALTHINSURANCEAVIF from '../images/HEALTHINSURANCEAVIF.avif';
import LIFEINSURANCE from '../images/LIFEINSURANCE.jpg'; // Adjust path as necessary
import INSHEROPIC from '../images/INSHEROPIC.jpg'; // Adjust path as necessary 
import LICARUL from '../images/LICARUL.jpg';
import Reviews from './Reviews';
import Topbar from './Topbar';

import Rating from './Rating';
import Upload from './Upload';


export default function Insurance() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  // State to manage open/close state of each FAQ item
  const [openFaq, setOpenFaq] = useState(null);

  // Toggle FAQ item
  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index); // Close if already open, otherwise open
  };
  return (
    <div>
      <div><Topbar/></div>
    <div><Navbar /></div>
    <div>
      <section id="hero" style={{ backgroundImage: `url(${INSHEROPIC})` }}>
        <div className="hero-content">
          <h1>APPOLLO AGENCY</h1>
          <p>LIFE,HEALTH,VEHICLE</p>
          <a href="tel:+919884226561" className="hero-btn">Book Service?</a>
        </div>
      </section>

      <section id="About">
        <div className='container'>
          <div className='row'>
            <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
              <h2>About</h2>
              <p>Welcome to Apollo Agency! With over 32 years of dedicated experience, we are proud to be your trusted partner for all your insurance needs. Whether it’s car insurance, bike insurance, house insurance, life insurance, or health insurance, we understand how crucial it is to have the right coverage for your peace of mind. Our expert team is here to ensure you receive the best plans tailored to your unique needs, offering protection and security for you and your loved ones.

At Apollo Agency, transparency is at the heart of our service. Trust is the foundation of our relationship with you, and that’s why we keep you informed at every step of the process. Our knowledgeable agents deliver high-quality service, explaining policy details, costs, and benefits to help you make confident decisions about your insurance.

Customer satisfaction is our top priority. We are committed to providing timely, reliable support, so you can count on us whenever you need assistance. From selecting the right coverage to managing claims efficiently, our team is ready to help you secure your future and protect what matters most.</p>
            </div>
          </div>
        </div>
      </section>



      <section id="PSRL">

<div className='container'>
<div className='row'>
<div className='col-lg-12 col-md-12 col-sm-12 col-12'>

<h2>LIFE | HEALTH | VEHICLE</h2>



</div>

</div>

</div>
</section>
      <section id="PSRL">

<div className='container'>
<div className='row'>
<div className='col-lg-12 col-md-12 col-sm-12 col-12'>


<h2>32+ YEARS Experiences</h2>


</div>

</div>

</div>
</section>






<section class="profile-section">
  <div class="profile-card">
    <div class="profile-picture">
    <img src={LICARUL} alt="Gallery Image 1" className="img-fluid rounded" /> 
    </div>
    <div class="profile-details">
      <center>
      <h2>Lic Arul</h2>
      <p><strong>Contact Number:</strong> +91 98400 84115</p>
      <p><strong>Email:</strong> <a href="mailto:licarul@yahoo.com">licarul@yahoo.com</a></p>
      <p><strong>Website:</strong> <a href="https://www.licarul.com" target="_blank">www.licarul.com</a></p>
      </center>
    </div>
  </div>
  
  <div class="profile-card">
    <div class="profile-picture">
    <img src={LICARUL} alt="Gallery Image 1" className="img-fluid rounded" /> 
    </div>
    <div class="profile-details">
      <h2>Real Estate (Appollo Agency)</h2>
      <p><strong>Contact Number:</strong> +91 98400 84115</p>
      <p><strong>Email:</strong> <a href="mailto:info.appolloagency@gmail.com">info.appolloagency@gmail.com</a></p>
      <p><strong>Website:</strong> <a href="https://www.appolloagency.com" target="_blank">www.appolloagency.com</a></p>
    </div>
  </div>
 
</section>











<section id="PSRL">

<div className='container'>
<div className='row'>
<div className='col-lg-12 col-md-12 col-sm-12 col-12'>

<img src={EXPLAININSURANCE} alt="Gallery Image 1" className="img-fluid rounded" /> 


</div>

</div>

</div>
</section>
<section id="PSRL">

<div className='container'>
<div className='row'>
<div className='col-lg-12 col-md-12 col-sm-12 col-12'>


<img src={HEALTHINSURANCEAVIF} alt="Gallery Image 1" className="img-fluid rounded" />

</div>

</div>

</div>
</section>






<section id="gallery" className="container my-5">
  {/* Row 1 */}
  <div className="row align-items-center mb-4">
    <div className="col-md-6 position-relative">
      <img src={LIFEINSURANCE} alt="Gallery Image 1" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Life Insurance</h3>
      </div>
    </div>
    <div className="col-md-6">
      <p>Welcome to Apollo Agency! With over 32 years of experience, we take immense pride in being your trusted partner for all your life insurance needs. We understand that securing your family’s future and financial well-being is one of the most significant decisions you can make. Our expert team is here to help you navigate the complexities of life insurance, ensuring you select the best coverage tailored to your unique goals.

At Apollo Agency, trust is the foundation of our service. We believe in complete transparency, offering clear and honest communication at every step of the process. Our experienced professionals work closely with you to explain the details of life insurance policies, costs, and benefits, empowering you to make confident and informed decisions.

With a commitment to reliability and customer satisfaction, we provide personalized guidance to help you protect what matters most. Whether you're planning for your family's security, future investments, or unexpected challenges, Apollo Agency is here to support you with unmatched expertise and dedication.

Choose Apollo Agency for all your life insurance needs—your trusted partner with over 32 years of experience, offering protection, peace of mind, and a secure future for you and your loved ones.</p>
    </div>
  </div>

  {/* Row 2 */}
  <div className="row align-items-center mb-4 flex-md-row-reverse">
    <div className="col-md-6 position-relative">
      <img src={CARINSURANCE} alt="Gallery Image 2" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Car Insurance</h3>
      </div>
    </div>
    <div className="col-md-6">
      <p>Apollo Agency provides affordable car insurance solutions, ensuring you get comprehensive coverage without exceeding your budget. With over 16 years of trusted service, our experienced team specializes in connecting clients with a wide variety of car insurance plans, offering protection and peace of mind for your vehicle.

At Apollo Agency, we prioritize transparency in pricing, offering honest guidance and tailored options to match your needs. Our dedicated professionals ensure a seamless process, helping you choose a policy that aligns with your driving habits and lifestyle.

Whether you're looking for third-party liability, comprehensive coverage, or add-on benefits, Apollo Agency is committed to delivering timely and effective assistance. We work with you every step of the way, ensuring you get the best value and the protection you deserve.

Choose Apollo Agency for car insurance—your reliable partner for safeguarding your vehicle and ensuring a stress-free experience on the road.







</p>
    </div>
  </div>

  {/* Row 3 */}
  <div className="row align-items-center mb-4">
    <div className="col-md-6 position-relative">
      <img src={BIKEINSURANCE} alt="Gallery Image 3" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Bike Insurance</h3>
      </div>
    </div>
    <div className="col-md-6">
      <p>Apollo Agency is your trusted partner for finding the perfect bike insurance plan that meets your needs and lifestyle. With over 16 years of experience, we specialize in connecting clients with a wide range of insurance options, ensuring comprehensive coverage for your two-wheeler at competitive rates.

At Apollo Agency, we prioritize transparency, offering clear and affordable pricing along with dependable assistance throughout the insurance process. Our team ensures that every policy is tailored to provide you with a seamless and stress-free experience.

We are committed to delivering fast and efficient service, helping you secure a bike insurance policy that fits your requirements and budget. Choose Apollo Agency for a reliable, hassle-free journey to protecting your bike and ensuring peace of mind on every ride.</p>
    </div>
  </div>


 {/* Row 2 */}
 <div className="row align-items-center mb-4 flex-md-row-reverse">
    <div className="col-md-6 position-relative">
      <img src={ALLINSURANCE} alt="Gallery Image 2" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>All vehicle Insurance</h3>
      </div>
    </div>
    <div className="col-md-6">
      <p>Apollo Agency provides affordable vehicle insurance solutions, ensuring you get the perfect coverage without stretching your budget. With over 16 years of trusted service, our experienced team specializes in connecting clients with a wide variety of insurance plans for all types of vehicles, from bikes and cars to commercial vehicles, ensuring comprehensive protection across all needs.

At Apollo Agency, we prioritize transparency in pricing, offering honest guidance and tailored options to match your requirements. Our dedicated professionals ensure a seamless insurance process, helping you secure a policy that aligns with your preferences and lifestyle.

Whether you're looking for third-party liability, comprehensive coverage, or add-on benefits, Apollo Agency is committed to delivering timely and effective assistance, ensuring you get the right coverage at the right cost.

Choose Apollo Agency for all vehicle insurance—your reliable and stress-free partner for protecting your vehicles and ensuring peace of mind on the road.</p>
    </div>
  </div>


</section>

<section id="why-choose-us">
  <div class="container">
    <h2>Why Choose Us?</h2>
    <div class="features">
      <div class="feature-box">
        <i class="icon fas fa-trophy"></i>
        <h3>Proven Expertise</h3>
        <p>Over a decade of experience delivering top-notch services to clients.</p>
      </div>
      <div class="feature-box">
        <i class="icon fas fa-user-check"></i>
        <h3>Customer Satisfaction</h3>
        <p>Our clients are our priority, and we go the extra mile to meet their needs.</p>
      </div>
      <div class="feature-box">
        <i class="icon fas fa-chart-line"></i>
        <h3>Results-Driven</h3>
        <p>We focus on achieving measurable outcomes for your success.</p>
      </div>
      <div class="feature-box">
        <i class="icon fas fa-headset"></i>
        <h3>24/7 Support</h3>
        <p>Our team is available around the clock to assist with any concerns.</p>
      </div>
    </div>
  </div>
</section>




<div><Reviews/></div>
    {/* Other sections */}
<section id="faq-insurance">
  <div className="container">
    <h2>FAQs - Frequently Asked Questions</h2>
    <div className="accordion">
      {[
        { 
          question: "How can Apollo Agency assist with house insurance?", 
          answer: "We provide expert guidance to help you choose the best house insurance policy, ensuring your property is adequately protected." 
        },
        { 
          question: "What services do you offer for life insurance?", 
          answer: "We offer a range of life insurance options tailored to your financial goals and family security, ensuring peace of mind for your loved ones." 
        },
        { 
          question: "Do you provide health insurance plans?", 
          answer: "Yes, we offer personalized health insurance plans that cover medical expenses and provide financial protection during health emergencies." 
        },
        { 
          question: "Can Apollo Agency help with bike insurance?", 
          answer: "Absolutely! We assist with selecting comprehensive and third-party bike insurance plans that suit your needs and budget." 
        },
        { 
          question: "Do you provide car insurance services?", 
          answer: "Yes, we offer car insurance options that include comprehensive coverage, third-party liability, and add-on benefits to ensure complete protection for your vehicle." 
        },
        { 
          question: "Why should I choose Apollo Agency for insurance?", 
          answer: "Our expertise, transparency, and partnerships with leading insurers ensure you get the best coverage at competitive rates." 
        },
        { 
          question: "Do you offer any discounts on insurance policies?", 
          answer: "Yes, we provide seasonal discounts, referral bonuses, and exclusive deals to make your insurance purchase more affordable." 
        },
      ].map((faq, index) => (
        <div className="accordion-item" key={index}>
          <div className="accordion-header" onClick={() => toggleFaq(index)}>
            <h3>{faq.question}</h3>
            <i className={`icon fas fa-chevron-${openFaq === index ? "up" : "down"}`}></i>
          </div>
          <div className={`accordion-content ${openFaq === index ? "open" : ""}`}>
            <p>{faq.answer}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>
 
<section id="contact-info">
  <h2>Contact Us</h2>
  <div class="contact-container">
    <div class="contact-item">
      <i class="fas fa-map-marker-alt"></i>
      <h3>Office Address</h3>
      <p>13.A, Sudhanadha Bharathi St.,</p>
      <p>East Tambaram, Chennai-600059</p>
    </div>
    <div class="contact-item">
      <i class="fas fa-phone-alt"></i>
      <h3>Contact</h3>
      <p>Phone: +919884226561<br/>Email: info.appolloagency@gmail.com</p>
    </div>
    <div class="contact-item">
      <i class="fas fa-map"></i>
      <h3>Map</h3>
      <p>
        <a href="https://www.google.com/maps?q=Chennai" target="_blank">View on Google Maps</a>
      </p>
    </div>
  </div>
</section>


      <section id="opening-hours">
  <h2>Opening Hours</h2>
  <table class="hours-table">
    <thead>
      <tr>
        <th>Day</th>
        <th>Time</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <i class="fas fa-calendar-day"></i> Monday to Saturday
        </td>
        <td>
          <i class="fas fa-clock"></i> 10 AM - 7 PM
          <br/>
          <i class="fas fa-utensils"></i> Lunch: 2 PM - 3 PM
        </td>
      </tr>
      <tr>
        <td>
          <i class="fas fa-calendar-day"></i> Sunday
        </td>
        <td>
          <i class="fas fa-times-circle"></i> Closed
        </td>
      </tr>
    </tbody>
  </table>
</section>
<div>
  <Rating />

<section id="refunds">
<div className='container'>
  <div className='row'>
    <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
      <p>Please View Our Refund Policy<Link to='/refundpolicy'>--more details</Link></p>
    </div>
  </div>
</div>

</section>



</div>
{/* <div><Upload/></div> */}

    <div><Footer /></div>
  </div>
  </div>
  )
}
